import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
@Injectable({
    providedIn: "root"
})
export class SeoService {
    private _renderer2: Renderer2;
    constructor(private title: Title, private meta: Meta,private router:Router ,private rendererFactory: RendererFactory2,@Inject(DOCUMENT) private _document: Document) { 
        this._renderer2 = this.rendererFactory.createRenderer(null, null);
    }
    script: HTMLScriptElement;
    updateTitle(title: string) {
        this.title.setTitle(title);
        this.meta.updateTag({ property: 'title', content: title });
    }

    updateMetaTag(name: string, property: string, desc: string) {        
        if (name === null) {
            this.meta.updateTag({ property: property, content: desc });
        } else {
            this.meta.updateTag({ name: name, content: desc });
        }
    }
    async callSchema() {
        const existingScripts = this._document.querySelectorAll('script[type="application/ld+json"]');
        existingScripts.forEach(script => {
          this._renderer2.removeChild(this._document.body, script);
        });
        // Call the addBreadcrumbSchema method to generate dynamic breadcrumbs
        const breadcrumbs = this.addBreadcrumbSchema(); // No need to pass hardcoded breadcrumbs
        
        // Convert the schema to a JSON string
        const jsonString = JSON.stringify(breadcrumbs);
        
        // Create a script element for the JSON-LD
        this.script = this._renderer2.createElement('script');
        this.script.type = 'application/ld+json';
        this.script.text = jsonString; // Directly assign the JSON string
        this.script.defer = true;
    
        // Append the script to the document's body
        this._renderer2.appendChild(this._document.body, this.script);
      }
      addBreadcrumbSchema() {
        const baseUrl = this.getBaseUrl();
        let segments = this.router.url.replace(baseUrl, "").split("/").filter(segment => segment);
      
        segments = segments.filter(segment => segment.toLowerCase() !== "product-listing");
      
        const stopSegment = "post";
        const stopIndex = segments.findIndex(segment => segment.toLowerCase() === stopSegment.toLowerCase());
      
        let filteredSegments;
      
        if (stopIndex !== -1) {
          filteredSegments = segments.slice(0, stopIndex + 1);
        } else {
          filteredSegments = segments;
        }
      
        const breadcrumbs = filteredSegments.map((segment, index) => {
          const breadcrumbUrl = `${baseUrl}/${filteredSegments.slice(0, index + 1).join("/")}`;
          return {
            name: this.formatBreadcrumbName(segment),
            item: breadcrumbUrl,
          };
        });
      
        breadcrumbs.unshift({
          name: "Home Page",
          item: baseUrl,
        });
      
        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": breadcrumb.name,
            "item": breadcrumb.item,
          })),
        };
      }
      
      private getBaseUrl(): string {
        // Assuming the base URL is the origin + the first part of the route
        const currentUrl = this.router.url.split('/')[1];
        return `https://fleetverse.tatamotors.com`;
      }
      private formatBreadcrumbName(segment: string): string {
        return segment
          .replace(/-/g, " ")
          .replace(/\b\w/g, char => char.toUpperCase());
      }
}
